import React, { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Box,
  Pagination,
  Tabs,
  Tab,
  Skeleton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Divider,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import InfoIcon from "@mui/icons-material/Info";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PersonIcon from "@mui/icons-material/Person";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { advanceSearch } from "../../../_helper/services/advanceSearchv2";
import { formatDistanceToNow } from "date-fns";
import CheckIcon from "@mui/icons-material/Check";
// import NPAVIEWPrint from "../../PopUp/NPAVIEWPrint";
import { useAuth } from "oidc-react";
import { getUserId, getUserRole } from "../../../_helper/helper";
import { useNavigate } from "react-router-dom";

const NotificationList = () => {
  const [data, setData] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [rowCount, setRowCount] = useState(null);
  const [priority, setPriority] = useState("all");
  const [transactionType, setTransactionType] = useState(" ");
  const [loading, setLoading] = useState(true);
  const pageSize = 5;
  const chipWidth = 140;
  const navigate = useNavigate();
  const currentRole = sessionStorage.getItem("currentRole");
  const filteredPriorityData = (data) => {
    return data.filter(
      (item) => !["FYI", "Urgent", "Non-Urgent"].includes(item?.Priority)
    );
  };

  const { userData } = useAuth();

  const getNoticeData = async () => {
    setLoading(true);
    let additionalWhere = "";

    if (
      priority !== "all" &&
      priority !== "Non-Urgent" &&
      priority !== "Notification"
    ) {
      additionalWhere += `priority = '${priority}'`;
    }

    if (priority == "Notification") {
      additionalWhere += `priority = 'Notification' AND EmployeeID != '${getUserId(
        userData
      )}'`;
    }

    if (priority == "Non-Urgent") {
      additionalWhere += `priority = 'Notification' AND EmployeeID = '${getUserId(
        userData
      )}'`;
    }

    if (transactionType?.trim() && transactionType !== "all") {
      additionalWhere += additionalWhere
        ? ` AND TransactionType = '${transactionType}'`
        : `TransactionType = '${transactionType}'`;
    }

    const payload = {
      tableName:
        currentRole == "REVIEWER"
          ? "fn_AllTransaction_Reviewer"
          : currentRole == "AGENCY-DIRECTOR"
          ? "fn_AllTransaction_Agency_Director"
          : "fn_AllTransaction",
      searchParams: JSON.stringify([
        {
          columnName: "userrole",
          operator: "=",
          value: getUserRole(userData),
          dataType: "varchar(max)",
          logicOperator: "AND",
        },
      ]),
      columns: "*",
      pageNumber: currPage,
      pageSize: pageSize,
      sortData: "[CreatedDate] desc",
      additionalWhere: additionalWhere,
      location: "global",
    };

    try {
      const response = await advanceSearch(payload);
      const { results, rowCount } = response;
      setData(results);
      setRowCount(rowCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNoticeData();
  }, [currPage, priority, transactionType]);

  const getBgColorPriority = (item) => {
    if (!item?.EmployeeID) return "#ba895d";
    if (item?.EmployeeID == Number(getUserId(userData))) return "#24695c";
    return "#ba895d";
  };

  const getBadgeBackgroundColor = (priority, item = {}) => {
    switch (priority) {
      case "Action Required":
        return "#d22d3d";
      case "Non-Urgent":
        return "#24695c";
      case "FYI":
        return "#717171";
      case "Notification":
        return getBgColorPriority(item);
      // return "#ba895d";
      case "Past Due":
        return "#e2c636";
      default:
        return "#D3D3D3";
    }
  };

  const getIconPriority = (item, color) => {
    if (!item?.EmployeeID) return <NotificationsIcon style={{ color }} />;
    if (item?.EmployeeID == Number(getUserId(userData)))
      return <LowPriorityIcon style={{ color }} />;
    return <NotificationsIcon style={{ color }} />;
  };

  const getIcon = (priority, color, item) => {
    switch (priority) {
      case "Action Required":
        return <PriorityHighIcon style={{ color }} />;
      case "Non-Urgent":
        return <LowPriorityIcon style={{ color }} />;
      case "FYI":
        return <InfoIcon style={{ color }} />;
      case "Notification":
        return getIconPriority(item, color);
      case "Past Due":
        return <ReportProblemIcon style={{ color }} />;
      default:
        return <EventNoteIcon style={{ color }} />;
    }
  };

  const getAllChipText = (item) => {
    if (item?.Priority === "Notification") {
      // if (!item?.EmployeeID) return "Notification";
      console.log(item, "item1221");
      if (item?.EmployeeID == Number(getUserId(userData)))
        return "My Notification";
      else return item?.Priority;
    } else {
      return item?.Priority;
    }
  };

  const getChipText = (priority, text, item) => {
    switch (priority) {
      case "Non-Urgent":
        return "My Notification";
      case "Notification":
        return "Notification";
      case "all":
        return getAllChipText(item);
      default:
        return text;
    }
  };

  const handlePageChange = (event, value) => {
    setCurrPage(value);
  };

  const handlePriorityChange = (event, newPriority) => {
    setPriority(newPriority);
    setCurrPage(1); // Reset to the first page whenever the priority changes
  };

  const handleTransactionTypeChange = (event) => {
    setTransactionType(event.target.value);
    setCurrPage(1); // Reset to the first page whenever the transaction type changes
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };
  // const [openNPAViewPrint, setOpenNPAViewPrint] = useState(false);
  // const [hrControlNumber, setHrControlNumber] = useState('');
  // const handleClick = (hrControlNumber) => {
  //   setOpenNPAViewPrint(true); // Open the dialog
  //   setHrControlNumber(hrControlNumber); // Set the HR control number
  // };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
          paddingLeft: "15px",
          boxSizing: "border-box",
        }}
      >
        <Tabs
          value={priority}
          onChange={handlePriorityChange}
          aria-label="priority"
          indicatorColor="none"
          textColor="primary"
          sx={{
            height: 40,
            minHeight: 40,
            "& .MuiTabs-indicator": {
              display: "none",
            },
            marginTop: "6px",
          }}
        >
          <Tab
            icon={<EventNoteIcon />}
            iconPosition="start"
            value="all"
            label="All"
            sx={{
              height: 40,
              minHeight: 40,
              backgroundColor: priority === "all" ? "#5f7ec4" : "inherit",
              color: priority === "all" ? "white" : "inherit",
              "&.Mui-selected": {
                color: "white",
              },
            }}
          />
          <Tab
            icon={<LowPriorityIcon />}
            iconPosition="start"
            value="Non-Urgent"
            label="My Notifications"
            sx={{
              height: 40,
              minHeight: 40,
              backgroundColor:
                priority === "Non-Urgent"
                  ? getBadgeBackgroundColor("Non-Urgent")
                  : "inherit",
              color: priority === "Non-Urgent" ? "white" : "inherit",
              "&.Mui-selected": {
                color: "white",
              },
            }}
          />
          {/* <Tab
            icon={<InfoIcon />}
            iconPosition="start"
            value="FYI"
            label="FYI"
            sx={{
              height: 40,
              minHeight: 40,
              backgroundColor:
                priority === "FYI" ? getBadgeBackgroundColor("FYI") : "inherit",
              color: priority === "FYI" ? "white" : "inherit",
              "&.Mui-selected": {
                color: "white",
              },
            }}
          /> */}
          <Tab
            icon={<NotificationsIcon />}
            iconPosition="start"
            value="Notification"
            label="All Notifications"
            sx={{
              height: 40,
              minHeight: 40,
              backgroundColor:
                priority === "Notification"
                  ? getBadgeBackgroundColor("Notification")
                  : "inherit",
              color: priority === "Notification" ? "white" : "inherit",
              "&.Mui-selected": {
                color: "white",
              },
            }}
          />
          <Tab
            icon={<PriorityHighIcon />}
            iconPosition="start"
            value="Action Required"
            label="Action Required"
            sx={{
              height: 40,
              minHeight: 40,
              backgroundColor:
                priority === "Action Required"
                  ? getBadgeBackgroundColor("Action Required")
                  : "inherit",
              color: priority === "Action Required" ? "white" : "inherit",
              "&.Mui-selected": {
                color: "white",
              },
            }}
          />
          <Tab
            icon={<ReportProblemIcon />}
            iconPosition="start"
            value="Past Due"
            label="Past Due"
            sx={{
              height: 40,
              minHeight: 40,
              backgroundColor:
                priority === "Past Due"
                  ? getBadgeBackgroundColor("Past Due")
                  : "inherit",
              color: priority === "Past Due" ? "white" : "inherit",
              "&.Mui-selected": {
                color: "white",
              },
            }}
          />
        </Tabs>

        <FormControl
          sx={{ minWidth: 150, marginRight: 2, marginBottom: "6px" }}
        >
          <InputLabel sx={{ top: -6 }}>Transaction Type</InputLabel>
          <Select
            value={transactionType}
            onChange={handleTransactionTypeChange}
            displayEmpty
            label="Transaction Type"
            sx={{ height: 40 }}
          >
            <MenuItem value=" ">
              <span>All</span>
            </MenuItem>
            <MenuItem value="Notification">Notification</MenuItem>
            <MenuItem value="Personal Action">Personal Action</MenuItem>
            <MenuItem value="Leave Application">Leave Application</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Divider style={{ marginTop: "-8px" }} />
      {loading ? (
        <List sx={{ padding: 2 }}>
          {[...Array(5)].map((_, index) => (
            <ListItem key={index} sx={{ marginBottom: "10px" }}>
              <ListItemAvatar>
                <Skeleton variant="circular" width={40} height={40} />
              </ListItemAvatar>
              <ListItemText
                primary={<Skeleton variant="text" />}
                secondary={<Skeleton variant="text" width="60%" />}
              />
            </ListItem>
          ))}
        </List>
      ) : filteredPriorityData(data).length === 0 ? (
        <Typography variant="h6" align="center" style={{ margin: "18px" }}>
          No Transactions
        </Typography>
      ) : (
        <List sx={{ padding: 0 }}>
          {filteredPriorityData(data).map((item, index) => (
            <ListItem
              key={index}
              sx={{
                borderBottom: "1px solid #e6edef",
                position: "relative",
                paddingTop: "0",
                paddingBottom: "0",
                ...(item?.Application === "Performance Evaluation" &&
                  item?.Priority == "Action Required" && { cursor: "pointer" }),
                ...(["Outside Employment", "Leave Application"].includes(
                  item?.TransactionType
                ) && {
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                    cursor: "pointer",
                  },
                }),
              }}
              onClick={() => {
                if (
                  item?.Application == "Performance Evaluation" &&
                  item.Priority == "Action Required"
                ) {
                  navigate(
                    `/performance-evaluation/${item?.ApplicationUserID}/${item?.ID}`
                  );
                }
                if (item?.TransactionType == "Leave Application") {
                  navigate(`/leaveapplication/${item?.EmployeeID}/${item?.ID}`);
                }
                if (item?.TransactionType == "Outside Employment") {
                  navigate(
                    `/outside-employment/${item?.EmployeeID}/${item?.ID}`
                  );
                }
              }}
            >
              {/* <ListItemAvatar>
                <Avatar>
                  {getIcon(item.Priority)}
                </Avatar>
              </ListItemAvatar> */}
              <ListItemText
                primary={
                  <>
                    <Box sx={{ display: "flex", gap: "4px" }}>
                      {getIcon(
                        item.Priority,
                        getBadgeBackgroundColor(item.Priority, item),
                        item
                      )}
                      <Typography
                        variant="body1"
                        component="div"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          fontWeight: "500",
                          fontSize: "16px",
                        }}
                      >
                        {item.Action_Description}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "gray",
                      }}
                    >{`${item.TransactionType}`}</Typography>
                  </>
                }
                secondary={
                  <Box
                    component="div"
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "200px",
                    }}
                  >
                    <Box
                      component="div"
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography variant="body2" sx={{ fontSize: "12px" }}>
                        HR Control:
                      </Typography>
                      {/* <Typography variant="body2" sx={{fontSize:"12px"}}>Effective Date:</Typography>
        <Typography variant="body2" sx={{fontSize:"12px"}}>Create Date:</Typography> */}
                      <Typography variant="body2" sx={{ fontSize: "12px" }}>
                        Status:
                      </Typography>
                    </Box>
                    <Box
                      component="div"
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", fontSize: "12px" }}
                      >
                        {item.HrControl}
                      </Typography>
                      {/* <Typography variant="body2" sx={{ fontWeight: 'bold',fontSize:"12px" }}>{formatDate(item.Effective_date)}</Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold',fontSize:"12px" }}>{formatDate(item.CreatedDate)}</Typography> */}
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", fontSize: "12px" }}
                      >
                        {item.Status}
                      </Typography>
                    </Box>
                  </Box>
                  // <>
                  //   <Typography variant="body2">{`HrControl: ${item.HrControl}`}</Typography>
                  //   <Typography variant="caption">
                  //     {`Create Date: ${formatDate(item.CreatedDate)} | Effective Date: ${formatDate(item.Effective_date)}`}
                  //   </Typography>
                  //   <Typography variant="body2">{`Status: ${item.Status}`}</Typography>
                  // </>
                }
              />
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 15,
                  textAlign: "right",
                }}
              >
                <Chip
                  label={getChipText(priority, item.Priority, item)}
                  sx={{
                    backgroundColor: getBadgeBackgroundColor(
                      item.Priority,
                      item
                    ),
                    color: "white",
                    // ml: 2,
                    borderRadius: "16px",
                    padding: "0 2px",
                    height: "32px",
                    width: `${chipWidth}px`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  bottom: 8,
                  right: 15,
                  display: "flex",
                  alignItems: "center",
                  gap: "7px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {/* <AccessTimeIcon sx={{ marginRight: "2px" }} fontSize='12px'/>
                <Typography variant="body2" sx={{fontSize:"12px"}}>
                  {formatDistanceToNow(new Date(item.CreatedDate), { addSuffix: true })}
                </Typography> */}
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "12px", color: "rgba(0,0,0,0.6)" }}
                  >
                    Created On:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "rgba(0,0,0,0.6)",
                    }}
                  >
                    {` ${formatDate(item.CreatedDate)}`}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {/* <AccessTimeIcon sx={{ marginRight: "2px" }} fontSize='12px'/>
                <Typography variant="body2" sx={{fontSize:"12px"}}>
                  {formatDistanceToNow(new Date(item.Effective_date), { addSuffix: true })}
                </Typography> */}
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "12px", color: "rgba(0,0,0,0.6)" }}
                  >
                    Effective On:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "rgba(0,0,0,0.6)",
                    }}
                  >
                    {` ${formatDate(item.Effective_date)}`}
                  </Typography>
                </Box>
              </Box>
            </ListItem>
          ))}
        </List>
      )}
      {filteredPriorityData(data) && filteredPriorityData(data)?.length > 0 && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1, mb: 1 }}>
          <Pagination
            count={Math.ceil(rowCount / pageSize)}
            page={currPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}
    </>
  );
};

export default NotificationList;
